//#region src/dom/popover.ts
const ZERO_OFFSETS = {
	sideOffset: 0,
	boundaryOffset: 0
};
const OPPOSITE_SIDE = {
	top: "bottom",
	bottom: "top",
	left: "right",
	right: "left"
};
function getSideAvailable(triggerRect, boundaryRect, side, offsets) {
	const boundaryOffset = offsets.boundaryOffset ?? 0;
	switch (side) {
		case "top": return triggerRect.top - boundaryRect.top - boundaryOffset - offsets.sideOffset;
		case "bottom": return boundaryRect.bottom - triggerRect.bottom - boundaryOffset - offsets.sideOffset;
		case "left": return triggerRect.left - boundaryRect.left - boundaryOffset - offsets.sideOffset;
		case "right": return boundaryRect.right - triggerRect.right - boundaryOffset - offsets.sideOffset;
	}
}
/**
* Resolve the preferred side against a positioning boundary.
*
* @internal
*/
function getPositionedSide(triggerRect, positionedRect, boundaryRect, opts, offsets = ZERO_OFFSETS) {
	const preferred = opts.side;
	const opposite = OPPOSITE_SIDE[preferred];
	const size = preferred === "top" || preferred === "bottom" ? positionedRect.height : positionedRect.width;
	const preferredSpace = getSideAvailable(triggerRect, boundaryRect, preferred, offsets);
	if (preferredSpace >= size) return preferred;
	return getSideAvailable(triggerRect, boundaryRect, opposite, offsets) > preferredSpace ? opposite : preferred;
}
/** @internal */
function tryShowPopover(el) {
	try {
		el?.showPopover?.();
	} catch {}
}
/** @internal */
function tryHidePopover(el) {
	try {
		el?.hidePopover?.();
	} catch {}
}
//#endregion
export { getPositionedSide, tryHidePopover, tryShowPopover };

//# sourceMappingURL=popover.js.map